import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";
import { ArrowLeft, Minus, Plus } from "lucide-react";

export default function ProductDetail() {
  const { id } = useParams();
  const { API, addToCart } = useApp();
  const [p, setP] = useState(null);
  const [qty, setQty] = useState(1);
  const [imgIdx, setImgIdx] = useState(0);
  const nav = useNavigate();

  useEffect(()=>{ axios.get(`${API}/products/${id}`).then(r=>setP(r.data)); }, [id, API]);
  if (!p) return <div className="p-20 text-center font-mono">LOADING...</div>;

  return (
    <div className="max-w-6xl mx-auto px-6 py-10" data-testid="product-detail">
      <Link to="/shop" className="font-mono text-xs inline-flex items-center gap-1 mb-6"><ArrowLeft size={14}/> BACK TO SHOP</Link>
      <div className="grid md:grid-cols-2 gap-10">
        <div>
          <div className="aspect-square border-2 border-[var(--ink)] bg-[var(--muted)] overflow-hidden mb-3">
            <img src={p.images?.[imgIdx]} className="w-full h-full object-cover" alt={p.name}/>
          </div>
          {p.images?.length > 1 && (
            <div className="flex gap-2">
              {p.images.map((img,i)=><button key={`${img.slice(0,32)}-${i}`} onClick={()=>setImgIdx(i)} className={`w-20 h-20 border-2 ${i===imgIdx?'border-[var(--accent)]':'border-[var(--ink)]'}`}><img src={img} className="w-full h-full object-cover"/></button>)}
            </div>
          )}
        </div>
        <div>
          <div className="font-mono text-xs tracking-widest text-[var(--accent)] mb-2">{p.category} · SKU {p.sku}</div>
          <h1 className="font-display text-4xl md:text-5xl mb-4">{p.name}</h1>
          <div className="flex items-baseline gap-3 mb-6">
            {p.original_price && p.original_price > p.price && <span className="font-mono text-2xl line-through text-[var(--ink-2)]">${p.original_price.toFixed(2)}</span>}
            <div className="font-display text-5xl">${p.price.toFixed(2)}</div>
            {p.original_price && p.original_price > p.price && <span className="font-display bg-[var(--accent)] text-white px-2 py-1 text-sm">SALE</span>}
          </div>
          <p className="text-[var(--ink-2)] mb-8 leading-relaxed">{p.description}</p>
          <div className="mb-6 font-mono text-sm">Stock: <span className={p.stock<5?'text-[var(--accent)]':''}>{p.stock} units</span></div>
          <div className="flex items-center gap-4 mb-6">
            <div className="flex items-center border-2 border-[var(--ink)]">
              <button onClick={()=>setQty(Math.max(1,qty-1))} className="p-3" data-testid="qty-minus"><Minus size={16}/></button>
              <span className="px-4 font-display text-lg" data-testid="qty-display">{qty}</span>
              <button onClick={()=>setQty(Math.min(p.stock,qty+1))} className="p-3" data-testid="qty-plus"><Plus size={16}/></button>
            </div>
            <button onClick={()=>{addToCart(p,qty); toast.success("Added to cart"); }} disabled={p.stock<1} className="btn-primary flex-1 disabled:opacity-40" data-testid="add-to-cart-btn">ADD TO CART</button>
          </div>
          <button onClick={()=>{addToCart(p,qty); nav("/cart");}} disabled={p.stock<1} className="btn-outline w-full" data-testid="buy-now-btn">BUY NOW</button>
        </div>
      </div>
    </div>
  );
}
